import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Row, Col, Table, Button, Form, Card, Tabs, Tab } from "react-bootstrap";
import { CustomerOrdersStore } from "../../../stores/CustomerOrdersStore";
import { STORE_CUSTOMER_ORDERS, STORE_REPORT3, STORE_CUSTOMERS } from "../../../constants";
import { formatMoney, formatShortDate } from "../../../common/Formatting";
import { wrapInput } from "../../../common/FormChangeWrapper";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { MultiSelect } from "../../../common/UI/MultiSelect";
import { Customer, CustomersStore, Report3BrandInfoItem, Report3Store } from "../../../stores";
import { NotificationLevel } from "../../../stores/NotificationStore";
import { SOURCES_ABTEKA, SOURCES_AS61, SOURCES_AB61 } from "../../../constants";
import { TableFooterPager } from "../../../common/UI/TableFooterPager";
import { SelectCustomerModal } from "../../../components/SelectCustomerModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RouteComponentProps } from "react-router-dom";
registerLocale('ru', ru)

interface IState {
    filterFormIsOpened: boolean;
    filteredManagerIds: string[];
    filteredStatuses: number[];
    dateFrom?: Date;
    dateTo?: Date;
    page: number;
    source?: string,
    selectCustomerModalIsOpened: boolean,
    selectedCustomerId?: string,
    selectedCustomerName?: string,
}


type Props = RouteComponentProps<{ page: string }>;

@inject(STORE_CUSTOMER_ORDERS, STORE_REPORT3, STORE_CUSTOMERS)
@observer
export class Report3Page extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            filterFormIsOpened: false,
            filteredManagerIds: [],
            filteredStatuses: [2],
            page: 1,
            source: "",
            selectCustomerModalIsOpened: false
        };
    }

    report3Store = (this.props as any)[STORE_REPORT3] as Report3Store;
    customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;
    customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;


    loadData = () => {
        if (this.state.filteredStatuses == undefined || this.state.filteredStatuses.length <= 0)
            this.report3Store._rootStore.notificationStore.addNotification("Не указан статус!", NotificationLevel.error);
        else
            this.report3Store.loadData(this.state.filteredManagerIds, this.state.filteredStatuses, this.state.source, this.state.selectedCustomerId, this.state.dateFrom, this.state.dateTo, this.state.page);
    }

    loadBrands = (customerId: string, loadNext = false) => {
        if (this.state.filteredStatuses == undefined || this.state.filteredStatuses.length <= 0)
            this.report3Store._rootStore.notificationStore.addNotification("Не указан статус!", NotificationLevel.error);
        else {
            this.report3Store.loadBrands(customerId, this.state.filteredManagerIds, this.state.filteredStatuses, this.state.source, this.state.dateFrom, this.state.dateTo, (loadNext ? this.report3Store.brandsCurrentPage + 1 : 1));
        }

    }
    hideBrands = () => {
        this.report3Store.hideBrands();
    }


    componentDidMount() {
        const savedFilter = JSON.parse(localStorage.getItem("report3Filter") || "{}");
        if (savedFilter.dateFrom != null) {
            savedFilter.dateFrom = new Date(savedFilter.dateFrom);
        }
        if (savedFilter.dateTo != null) {
            savedFilter.dateTo = new Date(savedFilter.dateTo);
        }

        this.setState(Object.assign({}, this.state, savedFilter), () => {
            this.customerOrdersStore.loadManagers();
            this.customerOrdersStore.loadStatuses();
        });

        const pageInt = this.props.match.params.page != undefined ? parseInt(this.props.match.params.page) : 1;

        this.setState({
            page: pageInt
        }, () => {
            this.loadData();
        });
    }

    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        if (prevProps.match.params.page != this.props.match.params.page) {
            const pageInt = this.props.match.params.page != undefined ? parseInt(this.props.match.params.page) : 1;

            this.setState({
                page: pageInt
            }, () => {
                this.loadData();
            });
        }
    }


    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            filteredManagerIds: [],
            filteredStatuses: [],
            source: "",
            dateFrom: undefined,
            dateTo: undefined,
            selectedCustomerId: undefined,
            selectedCustomerName: undefined,
        });
        localStorage.removeItem("report3Filter");
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        }, () => {
            this.saveFilterToLocalStorage();
        });
    }

    private saveFilterToLocalStorage = () => {
        if (this.state.filteredManagerIds == null
            && this.state.dateTo == null && this.state.dateFrom == null
            && this.state.selectedCustomerId == null
        ) {
            localStorage.removeItem("report3Filter");
            return;
        }
        localStorage.setItem("report3Filter", JSON.stringify({
            filteredManagerIds: this.state.filteredManagerIds,
            filteredStatuses: this.state.filteredStatuses,
            source: this.state.source,
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            filterFormIsOpened: true,
            selectedCustomerId: this.state.selectedCustomerId,
            selectedCustomerName: this.state.selectedCustomerName,
        }));
    }

    private openSelectCustomerModal = () => {
        if (this.state.source == "")
            this.customersStore._rootStore.notificationStore.addNotification("Источник не выбран!", NotificationLevel.error);
        else
            this.setState({ selectCustomerModalIsOpened: true });
    }


    render() {
        return [
            <TablePageHeader header="Отчет продаж по клиентам" reload={this.loadData} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.loadData();
                }}>

                    <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened} style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                        Фильтр
                    </Button>
                </Form>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={this.loadData}>Найти</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>
                                            <Form.Group controlId="filterForm.SelectSource">
                                                <Form.Label>Источник</Form.Label>
                                                <Form.Control as="select" size="sm"
                                                    value={this.state.source}
                                                    name="source"
                                                    onChange={wrapInput(this.changeFilter)}>

                                                    <option value="">Все</option>
                                                    <option value={SOURCES_AS61}>As61.ru</option>
                                                    <option value={SOURCES_AB61}>Ab61.ru</option>
                                                    <option value={SOURCES_ABTEKA}>Abteka.ru</option>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.SelectManager">
                                                <Form.Label>Статус</Form.Label>
                                                <MultiSelect
                                                    precheckedAll={false}
                                                    title="Статус"
                                                    data={this.customerOrdersStore.statuses.map(w => { return { Key: w.Key.toString(), Value: w.Value } })}
                                                    selectedItems={this.state.filteredStatuses.map(w => w.toString())}
                                                    onChange={(keys: string[]) => {
                                                        this.changeFilter("filteredStatuses", keys);
                                                    }}
                                                    width="100%"
                                                    size="sm"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2">
                                            <Form.Group controlId="filterForm.SelectManager">
                                                <Form.Label>Ответственный</Form.Label>
                                                <MultiSelect
                                                    precheckedAll={false}
                                                    title="Фильтр по менеджеру"
                                                    data={this.customerOrdersStore.managers}
                                                    selectedItems={this.state.filteredManagerIds}
                                                    onChange={(keys: string[]) => {
                                                        this.changeFilter("filteredManagerIds", keys);
                                                    }}
                                                    width="100%"
                                                    size="sm"
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.SelectClient">
                                                <Form.Label>Контрагент</Form.Label>
                                                <div className="form-inline" style={{
                                                    border: "1px solid #d8d8d8",
                                                    borderRadius: "3px",
                                                    padding: "0px 2px",
                                                    fontSize: "11pt",
                                                    cursor: "pointer"
                                                }}
                                                    onClick={this.openSelectCustomerModal}>
                                                    <div style={{ width: "100%", marginLeft: "-40px", paddingLeft: "40px" }}>
                                                        {this.state.selectedCustomerId == undefined ?
                                                            <span>Не выбрано</span> :
                                                            <span>{this.state.selectedCustomerName}</span>}

                                                    </div>
                                                    {this.state.selectedCustomerId == undefined ? [] :
                                                        <Button type="button" variant="link" size="sm" style={{ marginLeft: "-3px", marginRight: "-12px" }}
                                                            onClick={(e: any) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                this.setState({
                                                                    selectedCustomerId: undefined,
                                                                    selectedCustomerName: undefined
                                                                }, () => {
                                                                    this.saveFilterToLocalStorage()
                                                                });
                                                            }}>
                                                            <FontAwesomeIcon icon="times" style={{ color: "black" }} />
                                                        </Button>
                                                    }
                                                    <Button type="button" variant="link" size="sm" style={{
                                                        marginLeft: this.state.selectedCustomerId == undefined ? "9px" : "0"
                                                    }}>
                                                        <FontAwesomeIcon icon="caret-down" style={{ color: "black" }} />
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row> : [],
            <Row key="table_3">
                <Col sm={12}>
                    <Table bordered className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">Клиент</th>
                                <th className="text-center">UserID</th>
                                <th className="text-center">Номер телефона</th>
                                <th className="text-center">Email</th>
                                <th className="text-center">Организация</th>
                                <th className="text-center">Источник</th>
                                <th className="text-center">Количество</th>
                                <th className="text-center">Сумма заказов</th>
                            </tr>
                        </thead>
                        <TableFooterPager
                            columnsCount={6}
                            page={this.report3Store.currentPage}
                            totalCount={this.report3Store.totalOrdersCount}
                            pageSize={200}
                            move={"/reports/report3"}
                        />
                        <tbody>
                            {this.report3Store.items.map((item, index) => {
                                return [<tr key={index}>
                                    <td className="text-center" >
                                        <span>{item.customerFio}</span>
                                        {item.brands != undefined && item.brands.length > 0 ? <span className="pull-right" style={{ cursor: "pointer" }} title="Скрыть бренды"><FontAwesomeIcon icon="angle-up" onClick={this.hideBrands} /></span>
                                            :
                                            <span className="pull-right" style={{ cursor: "pointer" }} title="Показать бренды"><FontAwesomeIcon icon="angle-down" onClick={() => this.loadBrands(item.userId)} /></span>
                                        }
                                    </td>
                                    <td className="text-center">{item.userId}</td>
                                    <td className="text-center">{item.phoneNumber}</td>
                                    <td className="text-center">{item.email}</td>
                                    <td className="text-center">{item.organization}</td>
                                    <td className="text-center">{item.siteName}</td>
                                    <td className="text-center">{item.count}</td>
                                    <td className="text-center">{formatMoney(item.sum)}</td>
                                </tr>, item.brands != undefined && item.brands.length > 0 ? item.brands.map((brand, brIndex) => <tr key={`br_${brIndex}`}>
                                    <td colSpan={6} className="text-center">{brand.brandGroupName}</td>
                                    <td className="text-center">{brand.count}</td>
                                    <td className="text-center">{formatMoney(brand.sum)}</td>
                                </tr>)
                                    : [], (item.brands != undefined && item.brands.length > 0 && (this.report3Store.brandsCurrentPage * this.report3Store.brandsPageSize) < this.report3Store.brandsTotalItemsCount) ? <tr>
                                        <td className="text-center" colSpan={6}><a href="javascript:void(0)" onClick={() => this.loadBrands(item.userId, true)}>Показать еще</a></td>
                                    </tr> : []]

                            })}

                        </tbody>
                    </Table>
                </Col>
            </Row >,
            <SelectCustomerModal
                key="3"
                customersStore={this.customersStore}
                isOpened={this.state.selectCustomerModalIsOpened}
                source={this.state.source || "abteka"}
                onCustomerSelected={(customer: Customer) => {
                    this.setState({
                        selectCustomerModalIsOpened: false,
                        selectedCustomerId: customer.id,
                        selectedCustomerName: customer.friendlyName,
                    }, () => {
                        this.saveFilterToLocalStorage()
                    });
                }}
                openNewCustomerModal={() => { }}
                onHideHandler={() => { this.setState({ selectCustomerModalIsOpened: false }) }}
            />
        ]
    }
}